export default __webpack_public_path__ + "images/interior2_9be66ae42eb187761ec04bce2014f9c1.jpg";